export class ButtonType
{
	static Default = 'default'
	static Warning = 'warning'
	static Outline = 'outline'
	static AllTypes = [ButtonType.Default, ButtonType.Warning, ButtonType.Outline]

	static isValid(value)
	{
		return ButtonType.AllTypes.includes(value)
	}
}

export class ButtonSize
{
	static Default = 'default'
	static ExtraSmall = 'extra-small'
	static Dev = 'dev' //For debugging tools etc. that don't need stupid huge buttons
	static Small = 'small'
	static EndpointTable = 'endpoint'
	static AllTypes = [ButtonSize.Default, ButtonSize.ExtraSmall, ButtonSize.Small, ButtonSize.EndpointTable, ButtonSize.Dev]

	static isValid(value)
	{
		return ButtonSize.AllTypes.includes(value)
	}
}

export class ButtonWidth
{
	static Fit = 'fit'
	static Full = 'full'
	static AllTypes = [ButtonWidth.Fit, ButtonWidth.Full]

	static isValid(value)
	{
		return ButtonWidth.AllTypes.includes(value)
	}
}